import { createSelector } from 'reselect';
import values from 'ramda/es/values';
import pipe from 'ramda/es/pipe';
import filter from 'ramda/es/filter';


const selectCategories: any = createSelector(
  [
    ({ categories }) => categories,
    (_, dishesByCategory) => dishesByCategory,
  ],
  (categories, dishesByCategory) => pipe(
    values,
    filter(({ deleted, id }) => !deleted && dishesByCategory[id]),
  )(categories),
);

export default selectCategories
